import { GetMarketEffects } from './get-market.effects';
import { GetVetEffects } from './get-vet.effects';
import { VetEffects as LegacyVetEffects } from './vet.effects';

export const VetEffects = [GetVetEffects, GetMarketEffects, LegacyVetEffects];
